import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography, styled } from '@mui/material';
import { AnimatePresence, m } from 'framer-motion';
import { isMobile } from 'react-device-detect';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router';
import Image from '../../components/Image';
import useLocales from '../../hooks/useLocales';
import { varFade } from '../../components/animate';
import { useDispatch } from '../../redux/store';
import conObj from '../../utils/connection-assistant';
import { getOperatingSystem } from '../../utils/formatObject';
import { openLoginSignup } from '../../redux/slices/authPages';
import { calculateFontSize } from '../../utils/formatString';
import Iconify from '../../components/Iconify';
import { LoadingPageHTML } from './Const';

const VendorName = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  left: '50%',
  bottom: 0,
  transform: 'translateX(-50%)',
  width: '100%',
  height: '0.38rem',
  lineHeight: '.38rem',
  background: 'linear-gradient(180deg,transparent 0,rgba(0,0,0,.8))',
  fontSize: '.17rem',
  fontWeight: 600,
  color: '#fff',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  borderBottomLeftRadius: '.16rem',
  borderBottomRightRadius: '.16rem',
}));

const GameName = styled(Typography)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '0.3rem',
  margin: '.06rem 0 0',
  fontSize: '.2rem',
  color: '#181644',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

const GameContainer = ({
  item,
  companySlug = null,
  containerSx = {},
  imgWrapperSx = {},
  titleSx = {},
  lastSlotRef = null,
}) => {
  const isAuthenticated = localStorage.getItem('accessToken');

  const dispatch = useDispatch();

  const { translate } = useLocales();

  const [isShowOverlay, setIsShowOverlay] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [imageLoaded, setImageLoaded] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const navigate = useNavigate();

  const handleLaunchGame = (code) => {
    setIsLoading(true);

    const newTab = window.open();

    newTab.document.write(LoadingPageHTML);

    conObj
      .post(`games/launch/${code}.json`, {
        system_os: getOperatingSystem(),
        is_mobile: isMobile ? 1 : 0,
        return_url: window.location.href,
      })
      .then((res) => {
        if (res.status === 200) {
          const { status } = res.data.data;
          if (status === 1) {
            newTab.location.href = res.data?.data?.data?.url;
            setIsLoading(false);
          }
        }
      })
      .catch((err) => {
        const snackbarOptions = { variant: 'error', autoHideDuration: 5000 };
        enqueueSnackbar(err.message, snackbarOptions);
        console.log(`Server Error: ${err.message}`);
        setIsLoading(false);
        newTab.close();
      });
  };

  return (
    // Container
    <Box
      onClick={() => {
        if (companySlug) {
          if (!item?.is_maintenance_mode && !item?.is_single_game) {
            navigate(`/games/${companySlug}/${item?.id}`);
            // navigate(`/games/${companySlug}`, { state: { providerId: item?.id } });
            return;
          }
        }

        if (isAuthenticated) {
          if (item?.is_single_game && item?.single_game_game_code) handleLaunchGame(item?.single_game_game_code);
          else handleLaunchGame(item?.code);
        } else navigate('/auth/login');
      }}
      sx={{
        position: 'relative',
        width: '100%',
        cursor: 'pointer',
        overflow: 'hidden',
        ...containerSx,
      }}
      data-company={companySlug}
      ref={lastSlotRef}
    >
      {/* Image Wrapper */}
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          borderRadius: '0.16rem',
          ...imgWrapperSx,
        }}
      >
        <Image
          src={item?.photo_url || item?.icon_url || ''}
          alt={item.name}
          sx={{
            color: 'transparent',
            // width: '22vw',
            // height: '21vw',
            width: imageLoaded ? '100%' : '22vw', // Change width dynamically
            height: imageLoaded ? '100%' : '21vw', // Change height dynamically
            cursor: 'pointer',
            aspectRatio: '1 / 1',
            borderRadius: '0.16rem',
            // filter: `brightness(${item.is_maintenance_mode ? '0.2' : '1'}) blur(${isShowOverlay ? 3 : 0}px)`,
          }}
          afterLoad={() => setImageLoaded(true)}
          // onLoad={() => setImageLoaded(true)} // Set imageLoaded to true when image loads
        />
        {/* {companySlug === null && <VendorName>{item?.code?.split('-')[0]}</VendorName>} */}
      </Box>

      {companySlug === null && <GameName>{item?.name}</GameName>}

      {item.is_maintenance_mode && (
        <Typography
          sx={{
            position: 'absolute',
            color: '#ac0707',
            fontWeight: 600,
            textShadow: '0px 0px 1px #7f7f7f',
          }}
        >
          {translate('in_maintenance')}
        </Typography>
      )}
    </Box>
  );
};

GameContainer.propTypes = {
  item: PropTypes.object,
  onClick: PropTypes.func,
  containerSx: PropTypes.object,
  imgWrapperSx: PropTypes.object,
  titleSx: PropTypes.object,
};

export default GameContainer;
